import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { TableColumnType } from "src/app/constants/table";
import { MyQLERequestModel } from "src/app/models/qualifying-life-event";
import { TableColumn } from "src/app/models/table";
import { QLEService } from "src/app/services/qle.service";
import { EnrollmentOnboardService } from "src/app/services/enrollment-onboard.service";
import { MemberPaths } from "src/app/constants/routes";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { OnboardingEnrollmentsItem } from 'src/app/models/enrollment-onboard';

@Component({
    selector: 'mwp-member-qle',
    templateUrl: "./qle.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class QLEComponent implements OnInit {
    public apiUrl = ContentHeaderKey.EnrollmentLifeEventRequest;

    public displayList: boolean;
    public displayForm: boolean;
    public selectedQLE: MyQLERequestModel;
    public isNewRequest: boolean;

    public QLETableData: MatTableDataSource<MyQLERequestModel>;
    public QLEColumns: TableColumn[] = [
        {
            columnName: 'Life Event',
            propertyId: 'adminEventOptionDescription',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Date of Request',
            propertyId: 'dateOfRequest',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Date of Event',
            propertyId: 'eventDate',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Status',
            propertyId: 'displayStatusDescription',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Begin Enrollment',
            propertyId: 'canBeginEnrollment',
            columnType: TableColumnType.button,
            dataTypeText: 'Begin Enrollment',
            isBooleanPropertyId: 'canBeginEnrollment',
            width: '25%'
        },
        {
            columnName: 'View Request',
            propertyId: 'canEdit',
            columnType: TableColumnType.button,
            dataTypeText: 'View Request',
            isButtonSelection2: true,
            width: '20%'
        },
    ];

    constructor(
        private qleService: QLEService,
        private enrollmentService: EnrollmentOnboardService,
        private enrollmentOnboardService: EnrollmentOnboardService,
        private enrollmentManagerService: EnrollmentManagerService,
        private router: Router,
    ) {
    }

    ngOnInit(): void {
        this.loadList();
    }

    public loadList(): void {
        this.qleService.getQleRequests().subscribe((response: MyQLERequestModel[]) => {
            this.QLETableData = new MatTableDataSource<MyQLERequestModel>();
            this.QLETableData.data = response;

            if (this.qleService.dashboardQLEId) {
                this.viewEvent(response.find(r => r.id == this.qleService.dashboardQLEId));
                this.qleService.dashboardQLEId = null;
            } else {
                this.displayList = true;
                this.displayForm = false;
                this.isNewRequest = false;
                this.selectedQLE = null;
            }
        });
    }

    public startEnrollment(myQLERequestModel: MyQLERequestModel): void {
        this.enrollmentService.adminEventId = myQLERequestModel.adminEventID;
        this.enrollmentOnboardService.autoOnboardingQleBenefitRequest().subscribe((response: OnboardingEnrollmentsItem) => {
            this.enrollmentManagerService.setEnrollmentMode(response);
            this.router.navigateByUrl(MemberPaths.BenefitEnrollment);
        });
    }

    public viewEvent(myQLERequestModel: MyQLERequestModel): void {
        this.selectedQLE = myQLERequestModel;
        this.displayList = false;
        this.isNewRequest = false;
        this.displayForm = true;
    }

    public buildNewRequest(): void {
        this.displayList = false;
        this.isNewRequest =
            this.displayForm = true;
    }

    public closeForm(): void {
        this.displayList = true;
        this.displayForm = false;
        this.isNewRequest = false;
        this.selectedQLE = null;
    }
}
